<template>
  <el-card class="config-card"
           shadow="nerver">
    <el-tabs v-model="activeTabName"
             @tab-click="tabHandleClick">
      <!-- 目的地管理 -->
      <el-tab-pane label="目的地管理"
                   name="first">
        <!-- 搜索目的地 -->
        <div class="loc-search-add">
          <el-autocomplete class="inline-input"
                           size="mini"
                           v-model="state1"
                           placeholder="请输入要查询的目的地"
                           @select="handleSelect"></el-autocomplete>
          <el-button-group>
            <el-button @click="addDestOne"
                       size="mini"
                       type="primary"
                       icon="el-icon-plus"
                       plain>添加一级目的地</el-button>
            <el-button @click="addDestTwo"
                       size="mini"
                       type="primary"
                       icon="el-icon-plus"
                       plain>添加二级目的地</el-button>
            <el-button @click="addDestThree"
                       size="mini"
                       type="primary"
                       icon="el-icon-plus"
                       plain>添加三级目的地</el-button>
            <el-button @click="addDestFourth"
                       size="mini"
                       type="primary"
                       icon="el-icon-plus"
                       plain>添加四级目的地</el-button>
          </el-button-group>
        </div>

        <!-- 【一级】目的地 -->
        <el-dialog title="添加一级目的地（中国及大洲）"
                   :visible.sync="destOneVisible">
          <el-form :model="formDestOne">
            <el-form-item label="目的地中文名"
                          :label-width="formLabelWidth">
              <el-input size="mini"
                        v-model="formDestOne.name"></el-input>
            </el-form-item>
            <el-form-item label="目的地英文名"
                          :label-width="formLabelWidth">
              <el-input size="mini"
                        v-model="formDestOne.name_en"></el-input>
            </el-form-item>
            <el-form-item label="目的地拼音"
                          :label-width="formLabelWidth">
              <el-input size="mini"
                        v-model="formDestOne.name_py"></el-input>
            </el-form-item>
          </el-form>
          <!-- 对话框底部 -->
          <div slot="footer"
               class="dialog-footer">
            <el-button @click="destOneCancel"
                       size="mini">取 消</el-button>
            <el-button type="primary"
                       @click="destOneConfirm"
                       size="mini">提 交</el-button>
          </div>
        </el-dialog>

        <!-- 【二级】目的地 -->
        <el-dialog title="添加二级目的地"
                   :visible.sync="destTwoVisible">
          <el-form :model="formDestTwo">
            <el-form-item label="所属一级目的地"
                          :label-width="formLabelWidth">
              <el-select size="mini"
                         v-model="formDestTwo.valueDestOne"
                         filterable
                         placeholder="请选择所在地区">
                <el-option v-for="item in destOneList"
                           :key="item.value"
                           :label="item.loc_name"
                           :value="item.loc_id"></el-option>
              </el-select>
              <el-link href="https://zh.wikipedia.org/wiki/%E4%B8%AD%E5%8D%8E%E4%BA%BA%E6%B0%91%E5%85%B1%E5%92%8C%E5%9B%BD%E8%A1%8C%E6%94%BF%E5%8C%BA%E5%88%92%E4%BB%A3%E7%A0%81"
                       style="margin-left: 20px"
                       type="primary">中国行政地区码</el-link>
              <el-link href="https://zh.wikipedia.org/wiki/ISO_3166-1"
                       style="margin-left: 20px"
                       type="primary">国家代码（三位代码）
              </el-link>
            </el-form-item>
            <el-form-item label="地区中文名"
                          :label-width="formLabelWidth">
              <el-input size="mini"
                        v-model="formDestTwo.name"></el-input>
            </el-form-item>
            <el-form-item label="地区英文名"
                          :label-width="formLabelWidth">
              <el-input size="mini"
                        v-model="formDestTwo.name_en"></el-input>
            </el-form-item>
            <el-form-item label="地区拼音"
                          :label-width="formLabelWidth">
              <el-input size="mini"
                        v-model="formDestTwo.name_py"></el-input>
            </el-form-item>
            <el-form-item label="地区code"
                          :label-width="formLabelWidth">
              <el-input size="mini"
                        v-model="formDestTwo.code"></el-input>
            </el-form-item>
          </el-form>
          <!-- 对话框底部 -->
          <div slot="footer"
               class="dialog-footer">
            <el-button @click="destTwoCancel"
                       size="mini">取 消</el-button>
            <el-button type="primary"
                       @click="destTwoConfirm"
                       size="mini">确 定</el-button>
          </div>
        </el-dialog>

        <!-- 【三级】目的地 对话框 -->
        <el-dialog title="添加目的地-分区"
                   :visible.sync="destThreeVisible">
          <el-form :model="formDestThree">
            <!-- 选择1 -->
            <el-form-item label="目的地大区"
                          :label-width="formLabelWidth">
              <el-select size="mini"
                         v-model="formDestThree.valueDestOne"
                         filterable
                         placeholder="请选择大区"
                         @change="choiceOneDest(formDestThree.valueDestOne)">
                <el-option v-for="item in destOneList"
                           :key="item.value"
                           :label="item.loc_name"
                           :value="item.loc_id"></el-option>
              </el-select>
            </el-form-item>
            <!-- 选择2 -->
            <el-form-item label="目的地区域"
                          :label-width="formLabelWidth">
              <el-select size="mini"
                         v-model="formDestThree.valueDestTwo"
                         filterable
                         placeholder="请选择活动区域">
                <el-option v-for="item in destTwoList"
                           :key="item.value"
                           :label="item.loc_name"
                           :value="item.loc_id"></el-option>
              </el-select>
              <el-link href="https://zh.wikipedia.org/wiki/%E4%B8%AD%E5%8D%8E%E4%BA%BA%E6%B0%91%E5%85%B1%E5%92%8C%E5%9B%BD%E8%A1%8C%E6%94%BF%E5%8C%BA%E5%88%92%E4%BB%A3%E7%A0%81"
                       style="margin-left: 20px"
                       type="primary">中国行政地区码</el-link>
              <el-link href="https://apis.map.qq.com/ws/district/v1/list?key=WRJBZ-UC2KJ-D5QFA-KSYCT-ALR57-E4B2O"
                       style="margin-left: 20px"
                       type="primary">中国行政地区码(腾讯地图)</el-link>
            </el-form-item>

            <el-form-item label="分区中文名"
                          :label-width="formLabelWidth">
              <el-input size="mini"
                        v-model="formDestThree.name"></el-input>
            </el-form-item>
            <el-form-item label="分区英文名"
                          :label-width="formLabelWidth">
              <el-input size="mini"
                        v-model="formDestThree.name_en"></el-input>
            </el-form-item>
            <el-form-item label="分区拼音"
                          :label-width="formLabelWidth">
              <el-input size="mini"
                        v-model="formDestThree.name_py"></el-input>
            </el-form-item>
            <el-form-item label="分区code"
                          :label-width="formLabelWidth">
              <el-input size="mini"
                        v-model="formDestThree.code"></el-input>
            </el-form-item>
          </el-form>
          <!-- 对话框底部 -->
          <div slot="footer"
               class="dialog-footer">
            <el-button @click="destThreeCancel"
                       size="mini">取 消</el-button>
            <el-button type="primary"
                       @click="destThreeConfirm"
                       size="mini">确 定</el-button>
          </div>
        </el-dialog>
        <!-- 【四级】目的地 区域 对话框 -->
        <el-dialog title="添加目的地-分区"
                   :visible.sync="destFourthVisible">
          <el-form :model="formDestThree">
            <el-form-item label="目的地一级"
                          :label-width="formLabelWidth">
              <el-select size="mini"
                         v-model="formDestFourth.valueDestOne"
                         filterable
                         placeholder="请选择一级目的地"
                         @change="choiceOneDest(formDestFourth.valueDestOne)">
                <el-option v-for="item in destOneList"
                           :key="item.value"
                           :label="item.loc_name"
                           :value="item.loc_id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="目的地二级"
                          :label-width="formLabelWidth">
              <el-select size="mini"
                         v-model="formDestFourth.valueDestTwo"
                         filterable
                         placeholder="请选择二级目的地"
                         @change="choiceTwoDest(formDestFourth.valueDestTwo)">
                <el-option v-for="item in destTwoList"
                           :key="item.value"
                           :label="item.loc_name"
                           :value="item.loc_id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="目的地三级"
                          :label-width="formLabelWidth">
              <el-select size="mini"
                         v-model="formDestFourth.valueDestThree"
                         filterable
                         placeholder="请选择三级目的地">
                <el-option v-for="item in destThreeList"
                           :key="item.value"
                           :label="item.loc_name"
                           :value="item.loc_id"></el-option>
              </el-select>
            </el-form-item>
            <el-link href="https://zh.wikipedia.org/wiki/%E4%B8%AD%E5%8D%8E%E4%BA%BA%E6%B0%91%E5%85%B1%E5%92%8C%E5%9B%BD%E8%A1%8C%E6%94%BF%E5%8C%BA%E5%88%92%E4%BB%A3%E7%A0%81"
                     style="margin-left: 20px"
                     type="primary">中国行政地区码</el-link>
            <el-link href="https://apis.map.qq.com/ws/district/v1/list?key=WRJBZ-UC2KJ-D5QFA-KSYCT-ALR57-E4B2O"
                     style="margin-left: 20px"
                     type="primary">中国行政地区码(腾讯地图)</el-link>
            <!-- 填写四级目的地详细信息 -->
            <el-form-item label="分区中文名"
                          :label-width="formLabelWidth">
              <el-input size="mini"
                        v-model="formDestFourth.name"></el-input>
            </el-form-item>
            <el-form-item label="分区英文名"
                          :label-width="formLabelWidth">
              <el-input size="mini"
                        v-model="formDestFourth.name_en"></el-input>
            </el-form-item>
            <el-form-item label="分区拼音"
                          :label-width="formLabelWidth">
              <el-input size="mini"
                        v-model="formDestFourth.name_py"></el-input>
            </el-form-item>
            <el-form-item label="分区code"
                          :label-width="formLabelWidth">
              <el-input size="mini"
                        v-model="formDestFourth.code"></el-input>
            </el-form-item>
          </el-form>
          <!-- 对话框底部 -->
          <div slot="footer"
               class="dialog-footer">
            <el-button @click="destFourthCancel"
                       size="mini">取 消</el-button>
            <el-button type="primary"
                       @click="destFourthConfirm"
                       size="mini">确 定</el-button>
          </div>
        </el-dialog>

        <!-- 目的地展示class="el-icon-location" -->
        <h2 style="margin-bottom: 10px">目的地列表：</h2>
        <el-collapse v-model="activeDestNames"
                     @change="handleChange">
          <el-collapse-item v-for="(item, index) of destNameList"
                            :key="index"
                            :name="index">

            <template slot="title">
              <span class="level-one-style"> {{ item.loc_name }}</span>
            </template>
            <div class="level-two-area"
                 v-for="(i, loc_id) of item.children"
                 :key="loc_id">
              <!-- 二级 -->
              <span class="level-two-style"> {{ i.loc_name }}:</span>
              <!-- 三级 -->
              <!--  style="display:flex; flex-wrap:wrap; justify-content: flex-start;" -->
              <div style="display:flex; flex-wrap:wrap"
                   v-show="i.children">
                <div style="width: 15%;text-align:center;margin:10px"
                     v-for="(dest, index) of i.children"
                     :key="index">
                  <!-- 图片 文字 组 -->
                  <el-image style="width: 100px; height:100px "
                            :src="dest.cover"
                            fit="cover"></el-image>
                  <el-upload :accept="accept"
                             :name="file_name"
                             :action="$ip + '/add_cover_for_dest?dest_id='+dest.loc_id"
                             :on-success="handleAvatarSuccess"
                             :before-upload="beforeAvatarUpload">
                    <el-link size="mini"
                             :underline="false"
                             type="primary">点击上传</el-link>
                  </el-upload>
                  <div>
                    {{ dest.loc_name }}
                  </div>

                </div>

              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-tab-pane>
      <!-- 优惠券管理 -->
      <el-tab-pane label="优惠券管理"
                   name="sixth">
        <el-input type="textarea"
                  placeholder="请输入优惠券链接，多个链接用英文“;”分割"
                  v-model="discountLink"
                  show-word-limit
                  rows="10">
        </el-input>
        <span style="margin-top: 10px">优惠券到期日期：</span>
        <el-date-picker style="margin-top: 10px"
                        size="mini"
                        v-model="expDate"
                        type="date"
                        placeholder="选择优惠券到期日期"
                        format="yyyy 年 MM 月 dd 日"
                        value-format="yyyy-MM-dd">
        </el-date-picker>
        <el-button size="mini"
                   style="float: right; margin-top: 10px"
                   type="primary"
                   @click="saveDiscountLink">保存优惠券链接</el-button>
        <!-- 添加激活码 -->
        <el-input style="margin-top: 20px"
                  type="textarea"
                  placeholder="请输入激活码，多个链接用英文“;”分割"
                  v-model="activateCode"
                  show-word-limit
                  rows="10">
        </el-input>
        <el-button size="mini"
                   style="float: right; margin-top: 10px"
                   type="primary"
                   @click="saveActivateCode">保存激活码</el-button>
        <div class="activate_code_list_area">
          激活码：6e2366425ef8d304;ddc00aadca0bd821;5644728cf065fae6;7d63ab58cc2f03be;c993d90fe84e67cb;f6a10613deb9c94f;dc3761547f21214a;9cebce8109336799;39f4c938cd822673;1f57a4b02bbc6d64;2787cc4e61553fee;2fac80aeb5bdfd72;d9cfbd32246c16e1;1ab39a7b1c3c8a49;a3b86b0616f3e9c6;5e3ad5aac16a648c;20d8f8bd3bf11302;24d099a9de6e2ec7;36061ee402eaca85;44e5e19c32ecfec5;
        </div>
        <div class="activate_code_list_area">
          <el-input size="mini"
                    v-model="user_id"
                    style="width:20%"></el-input>
          <el-button size="mini"
                     @click="deleteDiscount">删除该账号优惠 : 1609285</el-button>
        </div>
      </el-tab-pane>
      <!-- 币种 管理 -->
      <el-tab-pane label="货币管理"
                   name="second">
        <!-- 搜索-->
        <div class="loc-search-add">
          <el-autocomplete class="inline-input"
                           size="mini"
                           v-model="state1"
                           placeholder="请输入要查询的目的地、或币种"
                           @select="handleSelect"></el-autocomplete>
          <el-button-group>
            <el-button @click="addCurrencyDest"
                       size="mini"
                       type="primary"
                       icon="el-icon-plus"
                       plain>添加币种与地区</el-button>
          </el-button-group>
        </div>
        <!-- 货币列表 -->
        <div>
          <el-table :data="currencyData"
                    style="width: 100%">
            <el-table-column prop="name"
                             label="货币名称"
                             width="180"></el-table-column>
            <el-table-column prop="num"
                             label="货币编号"
                             width="180"></el-table-column>
            <el-table-column prop="code"
                             label="货币代码"
                             width="180"></el-table-column>
            <el-table-column prop="name_en"
                             label="英文名"
                             width="180"></el-table-column>
            <el-table-column prop="country"
                             label="使用国家"
                             width="180"></el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <!-- 币种添加对话框 -->
      <el-dialog title="添加货币"
                 :visible.sync="addCurrencyDestVisable">
        <el-form :model="formAddCurrency"
                 label-width="100px">
          <el-form-item label="货币名称">
            <el-input class="currency_input"
                      size="mini"
                      v-model="formAddCurrency.name"></el-input>
          </el-form-item>
          <el-form-item label="货币英文名">
            <el-input class="currency_input"
                      size="mini"
                      v-model="formAddCurrency.name_en"></el-input>
          </el-form-item>
          <el-form-item label="货币代码">
            <el-input class="currency_input"
                      size="mini"
                      v-model="formAddCurrency.code"></el-input>
          </el-form-item>
          <el-form-item label="货币编号">
            <el-input class="currency_input"
                      size="mini"
                      v-model="formAddCurrency.num"></el-input>
          </el-form-item>
          <el-form-item label="货币使用地区">
            <el-cascader style="width: 300px"
                         size="mini"
                         :show-all-levels="false"
                         v-model="selectDests"
                         :options="option"
                         :props="defaultProp"
                         clearable
                         filterable></el-cascader>
          </el-form-item>
          <el-form-item>
            <el-link icon="el-icon-tickets"
                     type="primary"
                     href="https://zh.wikipedia.org/wiki/ISO_4217">参考货币代码ISO 4217</el-link>
          </el-form-item>
        </el-form>
        <!-- 对话框底部 -->
        <div slot="footer"
             class="dialog-footer">
          <el-button @click="cancelAddCurency"
                     size="mini">取 消</el-button>
          <el-button type="primary"
                     @click="submitCurencyDest"
                     size="mini">提 交</el-button>
        </div>
      </el-dialog>

      <!-- 退改规则管理 -->
      <el-tab-pane label="退改管理"
                   name="third">
        <div style="padding: 10px">
          <input-area-modify title="退改方案"
                             @save="saveRefoundRule"
                             button_name="添加"
                             input_textarea_width="500px"></input-area-modify>
        </div>

        <!-- 退改表格 -->
        <el-table ref="singleTable"
                  :data="refoundData"
                  highlight-current-row
                  style="width: 100%">
          <el-table-column prop="id"
                           label="方案号"
                           width="70"></el-table-column>
          <el-table-column prop="refund_info"
                           label="退改原则描述">
            <template slot-scope="slot">
              <p style="white-space: pre-wrap">{{ slot.row.refund_info }}</p>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           width="100"
                           fixed="right">
            <template slot-scope="scope">
              <el-button @click="deleteRefoundRule(scope.row.id)"
                         type="text"
                         size="small">删除</el-button>
              <!-- <el-button @click="changeRefoundRule(scope.row.id)"
                         type="text"
                         size="small">编辑</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <!-- 出行人信息模版管理 -->
      <el-tab-pane label="出行人信息模版"
                   name="four">
        <el-button style="float: right"
                   size="mini"
                   type="primary"
                   @click="openTravellerModify"
                   button_name="添加"
                   input_textarea_width="500px">添加出行人模版</el-button>
        <!-- 表格 -->
        <el-table :data="travellerTemplateData"
                  style="width: 100%">
          <el-table-column prop="id"
                           label="ID"
                           width="50%"></el-table-column>
          <el-table-column prop="template_name"
                           label="模版名称"
                           width="100%"></el-table-column>
          <el-table-column prop="mustFillIn"
                           label="是否必填"
                           width="100%">
            <template slot-scope="scope">
              <span v-if="scope.row.mustFillIn == true">必填</span>
              <span v-else>非必填</span>
            </template>
          </el-table-column>
          <el-table-column prop="fillInOneOrEveryOne"
                           label="填写数量"
                           width="100%">
            <template slot-scope="scope">
              <span v-if="scope.row.fillInOneOrEveryOne == true">一人一份</span>
              <span v-else>多人一份</span>
            </template>
          </el-table-column>

          <el-table-column label="模版内容">
            <template slot-scope="scope">
              <el-tag style="margin: 1px 5px"
                      v-for="(item, index) in scope.row.template"
                      :key="index"
                      size="medium"
                      color="white">{{ item }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column fixed="right"
                           prop="template_name"
                           label="操作"
                           width="100%">
            <template slot-scope="scope">
              <el-link :underline="false"
                       @click="editTravellerTemplate(scope.row)"
                       icon="el-icon-edit">编辑</el-link>
              <el-link :underline="false"
                       @click="deleteTravellerTemplate(scope.row.id)"
                       icon="el-icon-delete">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <!-- 出行人信息模版对话框 -->
      <traveller-template-modify ref="travellerTemplate"
                                 :traveller_template_id="traveller_template_id"
                                 :temp_id_list="temp_id_list"
                                 :cerdential_id_list="cerdential_id_list"
                                 :showtravellerTemplate.sync="showtravellerTemplate"
                                 @changeTravellerTemplate="changeTravellerTemplate"></traveller-template-modify>

      <!-- 行程信息模版管理 -->
      <!-- 添加模版的对话框 -->
      <res-template-modify ref="resveration_modify"
                           @close="closeResverationModify"
                           @cancelButton="cancelModifyButton"
                           @changeTemplate="changeTemplate"
                           :show.sync="resverationModify"></res-template-modify>
      <!-- 模版列表 -->
      <el-tab-pane label="行程信息模版"
                   name="five">
        <div>
          <el-button style="float: right"
                     size="mini"
                     type="primary"
                     @click="openDialogResverationModify()"
                     button_name="添加"
                     input_textarea_width="500px">添加行程信息模版</el-button>
        </div>
        <!-- 表格 -->
        <el-table :data="resTemplateData"
                  style="width: 100%">
          <el-table-column prop="id"
                           label="ID"
                           width="50%"></el-table-column>
          <el-table-column prop="template_name"
                           label="模版名称"
                           width="160%"></el-table-column>
          <el-table-column label="模版内容">
            <template slot-scope="scope">
              <el-tag style="margin: 1px 5px"
                      v-for="(item, index) in scope.row.template"
                      :key="index"
                      size="medium"
                      color="white">{{ item }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column fixed="right"
                           prop="template_name"
                           label="操作"
                           width="100%">
            <template slot-scope="scope">
              <el-link :underline="false"
                       @click="editTemplate(scope.row)"
                       icon="el-icon-edit">编辑</el-link>
              <el-link :underline="false"
                       @click="deleteTemplate(scope.row.id)"
                       icon="el-icon-delete">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import InputAreaModify from '../../components/common/modify/InputAreaModify'
import ResTemplateModify from '../../components/config/ResTemplateModify'
import TravellerTemplateModify from '../../components/config/TravellerTemplateModify'
export default {
  name: 'configpage',
  components: {
    'input-area-modify': InputAreaModify,
    'res-template-modify': ResTemplateModify,
    'traveller-template-modify': TravellerTemplateModify,
  },
  data() {
    return {
      // 优惠券管理
      discountLink: '',
      activateCode: '',
      expDate: '',
      // 出行人信息模版
      traveller_template_id: 0,
      showtravellerTemplate: false,
      travellerTemplateData: [],
      temp_id_list: [],
      cerdential_id_list: [],
      // 行程信息模版
      resTemplateData: [],
      // 退改原则
      resverationModify: false,
      refoundData: [],
      // 添加币种与地区
      currencyData: [],
      searchCurrencyDest: '',
      addCurrencyDestVisable: false,
      formAddCurrency: {
        name: '',
        name_en: '',
        code: '',
        num: '',
      },
      selectDests: [],
      defaultProp: {
        // element联级选择的 的props 属性，
        multiple: true,
        checkStrictly: true,
        label: 'loc_name', // 指定选项标签为选项对象的某个属性值
        value: 'loc_id', // 指定选项的值为选项对象的某个属性值
        children: 'children', // 指定选项的子选项为选项对象的某个属性值
      },
      option: [],
      // 添加目的地
      activeTabName: 'first',
      activeDestNames: ['1', '2', '3', '4'],
      destNameList: [],
      state1: '',
      destOneVisible: false,
      destTwoVisible: false,
      destThreeVisible: false,
      destFourthVisible: false,
      formLabelWidth: 'auto',
      //   value: "",
      formDestOne: {
        level: 1,
        pid: 0,
        name: '',
        name_en: '',
        name_py: '',
        code: '',
      },
      destOneList: [],
      formDestTwo: {
        level: 2,
        valueDestOne: '',
        name: '',
        name_en: '',
        name_py: '',
        code: '',
      },
      destTwoList: [],
      formDestThree: {
        level: 3,
        valueDestOne: '',
        valueDestTwo: '',
        name: '',
        name_en: '',
        name_py: '',
        code: '',
      },
      destThreeList: [],
      formDestFourth: {
        level: 4,
        valueDestOne: '',
        valueDestTwo: '',
        valueDestThree: '',
        name: '',
        name_en: '',
        name_py: '',
        code: '',
      },
      // 测试
      user_id: '',
      // 上传图片
      file_name: 'image',
      imageUrl: this.default_image, // 上传图片框 处 的 图片链接， 通过v-if判断，如果有则显示图片，如果没有则不显示图片
      image_url: '', // 返回的图片链接
      accept: this.accept_format,
    }
  },
  props: {
    accept_format: {
      type: String,
      default: '.jpg, .jpeg, .png, .gif',
    },
  },
  mounted() {
    this.getDestList()
  },
  methods: {
    // 测试
    deleteDiscount() {
      this.$http
        .get(`/test_delete_discount_link?user_id=${this.user_id}`)
        .then((res) => {
          if (res.data.errno == '0') {
            this.$message({
              message: res.data.errmsg,
              type: 'sucess',
            })
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    // 保存激活码
    saveActivateCode() {
      let activate_code = {
        activate_code: this.activateCode,
      }
      this.$http.post('/order/add_activate_code', activate_code).then((res) => {
        if (res.data.errno == '0') {
          this.$notify({
            title: '成功',
            message: res.data.errmsg,
            type: 'success',
          })
        } else {
          this.$message({
            message: res.data.errmsg,
            type: error,
          })
        }
      })
    },
    // 获取目前 库存 激活码
    getActivateCode() {
      this.$http.get('/order/get_activate_code').then((res) => {
        if (res.data.errno == '0') {
          this.activateCode = res.data.activate_code
        } else {
          this.$message({
            message: res.data.errmsg,
            type: error,
          })
        }
      })
    },
    // 获取目前 库存 优惠券链接
    getDiscountLink() {
      this.$http.get('/order/get_discount_links').then((res) => {
        console.log(res)
        if (res.data.errno == '0') {
          this.discountLink = res.data.discount_link
        } else {
          this.$message({
            message: res.data.errmsg,
            type: error,
          })
        }
      })
    },
    // 保存优惠券链接
    saveDiscountLink() {
      let links = {
        links: this.discountLink,
        exp_date: this.expDate,
      }
      this.$http.post('/order/save_discount_link', links).then((res) => {
        console.log(res)
        if (res.data.errno == '0') {
          this.$notify({
            title: '成功',
            message: res.data.errmsg,
            type: 'success',
          })
        }
      })
    },
    // 出行人信息相关
    openTravellerModify() {
      this.showtravellerTemplate = !this.showtravellerTemplate
    },
    editTravellerTemplate(value) {
      let traveller_info_list = []
      let cerdential_content_list = []
      this.traveller_template_id = value.id
      this.$refs.travellerTemplate.button_type = 2
      this.$refs.travellerTemplate.travellerModifyName = value.template_name
      this.$http.get(`/get_traveller_template?id=${value.id}`).then((res) => {
        const { data, errno, errmsg } = res.data
        if (errno == '0') {
          //
          if (data[0].fillInOneOrEveryOne == false) {
            this.$refs.travellerTemplate.travellerModifyOneOrEveryOne = 0
          } else {
            this.$refs.travellerTemplate.travellerModifyOneOrEveryOne = 1
          }
          //
          if (data[0].mustFillIn == false) {
            this.$refs.travellerTemplate.travellerModifyMustFillIn = 0
          } else {
            this.$refs.travellerTemplate.travellerModifyMustFillIn = 1
          }
          //
          if (data[0].template) {
            this.template_list = new Function('return ' + data[0].template)()
            for (let item of this.template_list) {
              traveller_info_list.push(item.id)
              // 证件已选项
              if (item.select) {
                for (let i of item.select) {
                  cerdential_content_list.push(i.id)
                }
              }
              //
            }
          }
        }
        this.temp_id_list = traveller_info_list
        this.cerdential_id_list = cerdential_content_list
        console.log(this.cerdential_id_list)
        this.showtravellerTemplate = true
      })
    },
    deleteTravellerTemplate(value) {
      this.$confirm('此操作将永久删除模版, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$http
            .get(`/delete_traveller_template?template_id=${value}`)
            .then((res) => {
              const { errno, errmsg } = res.data
              if (errno == '0') {
                this.$message({
                  type: 'success',
                  message: '删除成功!',
                })
              } else {
                this.$notify.error({
                  title: '错误',
                  message: errmsg,
                })
              }
            })
          this.tabHandleClick()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },

    // 预定信息模版相关
    openDialogResverationModify() {
      this.$refs.resveration_modify.button_type = 1
      this.resverationModify = true
    },
    closeTravellerModify(value) {
      this.resverationModify = value
    },
    // 关闭对话框
    closeResverationModify() {
      this.$http.get('/get_reservation_stencil').then((res) => {
        // console.log(res);
        const { data, errno, errmsg } = res.data
        this.resTemplateData = data
        let templateData_list = []
        for (let i of data) {
          // 构建对象
          const template_item = {}
          template_item.id = i.id
          template_item.template_name = i.template_name

          // 取出列表内容
          const item_template = i.template
          // 将template的字符串内容，变更为 对象
          let item_template_dict = new Function('return ' + item_template)()

          const item_template_list = []
          for (let item of item_template_dict) {
            item_template_list.push(item.name)
          }
          template_item.template = item_template_list
          // console.log(template_item);
          templateData_list.push(template_item)
        }
        this.$refs.resveration_modify.resverationModifyName = ''
        this.$refs.resveration_modify.reservationModify = []
        this.$refs.resveration_modify.modifyChecked = []
        this.resTemplateData = templateData_list
      })
    },
    // 关闭对话框按钮
    cancelModifyButton() {},
    // 确认提交新行程信息模版
    // 编辑模版按钮
    editTemplate(template_item) {
      // 匹配 模版名称
      this.$refs.resveration_modify.template_id = template_item.id
      this.$refs.resveration_modify.button_type = 2
      this.$refs.resveration_modify.resverationModifyName =
        template_item.template_name
      // 匹配模版内容
      this.$refs.resveration_modify.modifyChecked = template_item.template
      // 显示对话框
      this.resverationModify = true
      // 发送请求获取模版数据
      // this.$http
      //   .get(`get_reservation_stencil?id=${template_item.id}`)
      //   .then(res => {
      //     const { data, errmsg, errno } = res.data;
      //     // console.log(data[0].template);
      //     let template_obj = new Function("return" + data[0].template)();
      //     // console.log(template_obj);
      //     this.$refs.resveration_modify.reservationModify = template_obj;
      //   });
      // console.log(template_item);
    },
    // 提交修改的按钮
    changeTemplate() {
      // 刷新页面
      this.tabHandleClick()
    },
    changeTravellerTemplate() {
      // 刷新页面
      this.tabHandleClick()
    },
    deleteTemplate(id) {
      this.$confirm('是否删除该模版?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          // 发送请求数据
          this.$http
            .get(`/get_reservation_stencil?id=${id}&delete=1`)
            .then((res) => {
              // console.log(res);
              const { data, errmsg, errno } = res.data
              if (errno == '0') {
                this.$notify({
                  title: '成功',
                  message: errmsg,
                  type: 'success',
                })
              }
            })

          this.$message({
            type: 'success',
            message: '删除成功!',
          })
          // 更新数据表
          this.tabHandleClick()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    // 添加出行人信息模版
    openDialogTravellerModify() {},
    // 添加退改方案----------------
    saveRefoundRule(content) {
      // console.log(content);
      let refund_info = {}
      refund_info.refund_info = content
      // console.log(refund_info);
      this.$http.post('/product/add_refund_info', refund_info).then((res) => {
        if (res.data.errno == '0') {
          this.$notify({
            title: '成功',
            message: res.data.errmsg,
            type: 'success',
          })
          this.$http.get('/product/get_refund_info').then((res) => {
            // console.log(res);
            this.refoundData = res.data.data
          })
        }
      })
    },
    deleteRefoundRule(id) {
      // console.log(id); 删除一个退改
      this.$confirm('此操作将删除该退改原则, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$http
            .get(`/product/delete_refund_info?id=${id}`)
            .then((res) => {})
          this.$message({
            type: 'success',
            message: '删除成功!',
          })
          this.$http.get('/product/get_refund_info').then((res) => {
            // console.log(res);
            this.refoundData = res.data.data
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    changeRefoundRule(id) {
      this.$prompt('修改退改原则', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(({ value }) => {
          this.$http
            .post('/product/change_refund_info', {
              id: id,
              new_refund_info: value,
            })
            .then((res) => {
              this.$message({
                type: 'success',
                message: res.data.errmsg,
              })
              this.$http.get('/product/get_refund_info').then((res) => {
                // console.log(res);
                this.refoundData = res.data.data
              })
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入',
          })
        })
    },
    // 添加币种与地区 相关方法----------------
    addCurrencyDest() {
      this.addCurrencyDestVisable = true
      this.loadDest()
    },
    cancelAddCurency() {
      //关闭对话框
      this.addCurrencyDestVisable = false
    },
    submitCurencyDest() {
      //向服务端提交添加货币信息
      let currecy_info = {}
      currecy_info.code = this.formAddCurrency.code
      currecy_info.name = this.formAddCurrency.name
      currecy_info.num = parseInt(this.formAddCurrency.num)
      currecy_info.name_en = this.formAddCurrency.name_en
      // console.log(this.formAddCurrency);
      let currency_dest_list = []

      // console.log(this.selectDests);
      for (let i of this.selectDests) {
        // i 是一个列表，取他的最后一个数装进currency_dest_list 中即可

        currency_dest_list.push(i[i.length - 1])
      }
      currecy_info.country_id = currency_dest_list
      // console.log(currecy_info);
      // 发生请求
      this.$http.post('/add_currency', currecy_info).then((res) => {
        // console.log(res);
        const { errmsg, errno } = res.data
        if (errno == '0') {
          this.$notify({
            title: '成功',
            message: errmsg,
            type: 'success',
          })
          this.addCurrencyDestVisable = false
        } else if (
          errno == '4003' ||
          errno == '4004' ||
          errno == '4002' ||
          errno == '4001'
        ) {
          this.$notify.error({
            title: '错误',
            message: errmsg,
          })
        }
      })
    },
    // 获取目的地信息
    loadDest() {
      this.$http.get('/get_dest_level').then((res) => {
        this.option = res.data.data
        // console.log(this.option);
      })
    },

    handleSelect() {}, // 从输入框中选择时
    // 添加目的地 相关方法 ---------------------
    // 打开添加目的地对话框
    addDestOne() {
      this.destOneVisible = true
    },
    // 打卡对话框的按钮【添加二级】
    addDestTwo() {
      this.destTwoVisible = true
      console.log('打开二级添加对话框')
      // 请求 一级目的地信息 的数据，添加到 选项中
      this.$http.post('/get_dest', { level: 1 }).then((res) => {
        const { data, errno, errmsg } = res.data
        if (errno == '0') {
          this.destOneList = data
        }
      })
    },
    // 打卡对话框的按钮【添加三级】

    addDestThree() {
      this.destThreeVisible = true
      console.log('打开三级添加对话框')

      // 请求 一级目的地信息 的数据，添加到 选项中
      this.$http.post('/get_dest', { level: 1 }).then((res) => {
        const { data, errno, errmsg } = res.data
        if (errno == '0') {
          this.destOneList = data
        }
      })
    },
    // 打卡对话框的按钮【添加四级】
    addDestFourth() {
      this.destFourthVisible = true
      console.log('打开四级添加对话框')

      // 请求 一级目的地信息 的数据，添加到 选项中
      this.$http.post('/get_dest', { level: 1 }).then((res) => {
        const { data, errno, errmsg } = res.data
        if (errno == '0') {
          this.destOneList = data
        }
      })
    },
    choiceOneDest(value) {
      //选择一级目的地后触发，获取level ，并请求二级目的地
      this.$http.post('/get_dest', { pid: value }).then((res) => {
        console.log(res)
        const { data, errno, errmsg } = res.data
        if (errno == '0') {
          this.destTwoList = data
        }
      })
    },
    choiceTwoDest(value) {
      console.log(value)
      //选择一级目的地后触发，获取level ，并请求二级目的地
      this.$http.post('/get_dest', { pid: value }).then((res) => {
        console.log('三级', res)
        const { data, errno, errmsg } = res.data
        if (errno == '0') {
          this.destThreeList = data
        }
      })
    },
    // 对话框 确认 与 取消
    destOneCancel() {
      this.destOneVisible = false
    },
    destOneConfirm() {
      this.$http.post('/add_destn', this.formDestOne).then((res) => {
        const { errmsg, errno } = res.data
        if (errno == '0') {
          //关闭对黄框
          this.destOneVisible = false
          this.$notify({
            title: '成功',
            message: errmsg,
            type: 'success',
          })
          this.formDestOne = {
            level: 1,
            pid: 0,
            name: '',
            name_en: '',
            name_py: '',
            code: '',
          } // 提交后清空表单数据
        } else if (errno == '4002') {
          this.$notify({
            title: '请检查添加的内容，确保完整',
            message: errmsg,
            type: 'error',
          })
        } else if (errno == '4003') {
          this.$notify({
            title: '目的地添加失败',
            message: errmsg,
            type: 'error',
          })
        }
      })
    },
    destTwoCancel() {
      this.destTwoVisible = false
    },
    destTwoConfirm() {
      this.$http.post('/add_destn', this.formDestTwo).then((res) => {
        const { errmsg, errno } = res.data
        console.log(res)
        if (errno == '0') {
          this.destTwoVisible = false
          this.$notify({
            title: '成功',
            message: errmsg,
            type: 'success',
          })
          this.formDestTwo = {
            level: 2,
            valueDestOne: '',
            name: '',
            name_en: '',
            name_py: '',
            code: '',
          } // 提交后清空表单数据
        } else if (errno == '4002') {
          this.$notify({
            title: '请检查添加的内容，确保完整',
            message: errmsg,
            type: 'error',
          })
        } else if (errno == '4003') {
          this.$notify({
            title: '目的地添加失败',
            message: errmsg,
            type: 'error',
          })
        }
      })
    },
    destThreeCancel() {
      this.destThreeVisible = false
    },

    destThreeConfirm() {
      this.$http.post('/add_destn', this.formDestThree).then((res) => {
        const { errmsg, errno } = res.data
        if (errno == '0') {
          this.destThreeVisible = false
          this.$notify({
            title: '成功',
            message: errmsg,
            type: 'success',
          })
          this.formDestThree = {
            level: 3,
            valueDestOne: '',
            name: '',
            name_en: '',
            name_py: '',
            code: '',
          } // 提交后清空表单数据
        } else if (errno == '4002') {
          this.$notify({
            title: '请检查添加的内容，确保完整',
            message: errmsg,
            type: 'error',
          })
        } else if (errno == '4003') {
          this.$notify({
            title: '目的地添加失败',
            message: errmsg,
            type: 'error',
          })
        }
      })
    },
    destFourthCancel() {
      this.destFourthVisible = false
    },

    destFourthConfirm() {
      // console.log(this.formDestFourth)
      this.$http.post('/add_destn', this.formDestFourth).then((res) => {
        const { errmsg, errno } = res.data
        if (errno == '0') {
          this.destFourthVisible = false
          this.$notify({
            title: '成功',
            message: errmsg,
            type: 'success',
          })
          this.formDestThree = {
            level: 3,
            valueDestOne: '',
            name: '',
            name_en: '',
            name_py: '',
            code: '',
          } // 提交后清空表单数据
        } else if (errno == '4002') {
          this.$notify({
            title: '请检查添加的内容，确保完整',
            message: errmsg,
            type: 'error',
          })
        } else if (errno == '4003') {
          this.$notify({
            title: '目的地添加失败',
            message: errmsg,
            type: 'error',
          })
        }
      })
    },

    // 目的地
    querySearch() {}, //搜索框功能
    handleChange() {},
    getDestList() {
      this.$http.get('/get_dest_level').then((res) => {
        console.log(res.data.data)
        this.destNameList = res.data.data
      })
    },

    // ------------------------------- tab切换 ------------------------------
    tabHandleClick() {
      //切换标签时对应的tab 方法
      if (this.activeTabName == 'first') {
        this.$http.get('/get_dest_level').then((res) => {
          console.log(res.data.data)
          this.destNameList = res.data.data
        })
      } else if (this.activeTabName == 'sixth') {
        this.getActivateCode()
        this.getDiscountLink()
      } else if (this.activeTabName == 'second') {
        this.$http.get('/get_currency').then((res) => {
          // console.log(res);
          this.currencyData = res.data.data
        })
      } else if (this.activeTabName == 'third') {
        this.$http.get('/product/get_refund_info').then((res) => {
          // console.log(res);
          this.refoundData = res.data.data
        })
      } else if (this.activeTabName == 'five') {
        this.$http.get('/get_reservation_stencil').then((res) => {
          // console.log(res);
          const { data, errno, errmsg } = res.data
          this.resTemplateData = data
          let templateData_list = []
          for (let i of data) {
            // 构建对象
            const template_item = {}
            template_item.id = i.id
            template_item.template_name = i.template_name

            // 取出列表内容
            const item_template = i.template
            // 将template的字符串内容，变更为 对象
            let item_template_dict = new Function('return ' + item_template)()

            const item_template_list = []
            for (let item of item_template_dict) {
              item_template_list.push(item.name)
            }
            template_item.template = item_template_list
            // console.log(template_item);
            templateData_list.push(template_item)
          }

          this.resTemplateData = templateData_list
        })
      } else if (this.activeTabName == 'four') {
        this.$http.get('/get_traveller_template').then((res) => {
          const { data, errno, errmsg } = res.data
          // console.log(data);
          let templateData_list = []

          for (let template of data) {
            const template_item = {}
            template_item.id = template.id
            template_item.template_name = template.template_name
            template_item.mustFillIn = template.mustFillIn
            template_item.fillInOneOrEveryOne = template.fillInOneOrEveryOne
            // 取出列表内容
            const item_template = template.template
            if (item_template) {
              // 将template的字符串内容，变更为 对象
              let item_template_dict = new Function('return ' + item_template)()
              const item_template_list = []
              for (let item of item_template_dict) {
                item_template_list.push(item.name)
              }
              template_item.template = item_template_list
            }
            // console.log(template_item);
            templateData_list.push(template_item)
          }
          this.travellerTemplateData = templateData_list
        })
      }
    },
    // 上传
    beforeAvatarUpload(file) {
      // console.log(file);
      const isFORMAT =
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/gif'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isFORMAT) {
        this.$message.error(`上传头像图片只能是 ${accept_format} 格式!`)
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      //   console.log(file);
      return isFORMAT && isLt2M
    },
    // 【上传成功】时的钩子函数，将返回值添加到页面中
    handleAvatarSuccess(res, file) {
      if (res.errno == '4101' || res.errno == '4602') {
        this.$notify({
          title: '警告',
          message: res.errmsg,
          type: 'warning',
        })
        return
      } else if (res.errno == '0') {
        // 发送事件给父组件
        console.log(this.image_url)
        // 刷新
        this.destNameList = []
        this.getDestList()
      }
    },
  },
}
</script>

<style>
.config-card {
  padding-bottom: 20%;
}

.loc-search-add {
  text-align: right;
  margin-bottom: 20px;
}

.loc-search-add button {
  margin-left: 10px;
}

.currency_input {
  width: 300px;
}
.level-one-style {
  font-size: 15px;
  margin-left: 3px;
}
.level-two-area {
  margin-left: 10px;
  margin-bottom: 10px;
  background-color: cornsilk;
  padding: 5px 10px 5px;
  border-radius: 5px;
}
.level-two-style {
  display: block;
  width: 100%;
  font-weight: bolder;
}

.activate_code_list_area {
  margin-top: 50px;
  width: 80%;
  /* word-wrap: break-word; */
  word-break: break-all;
}
</style>